export class PromiseCancellationToken {
    private _cancelled: boolean = false;

    get isCancellationRequested() {
        return this._cancelled;
    }

    public throwIfCancellationRequested() {
        if (this.isCancellationRequested) {
            throw new OperationCancelledError();
        }
    }

    public cancel() {
        console.log('Token cancelled');
        // throw Error('Canceled');
        this._cancelled = true;
    }
}

export class OperationCancelledError extends Error {
    constructor() {
        super('Operation was cancelled');
    }
}
